import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"

interface UserAvatarProps {
  src?: string
  name: string
  className?: string
  size?: "sm" | "md" | "lg" | "xl"
}

const sizeClasses = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-12 h-12",
  xl: "w-16 h-16",
}

const stringPlaceholder = (text = "") => {
  const placeholders = [1, 2, 3, 4, 5] // imágenes disponibles
  // Suma todos los charCode del string
  const total = [...text].reduce((sum, char) => sum + char.charCodeAt(0), 0)
  // Obtiene el último dígito de la suma
  const lastDigit = total % 10
  // Mapea ese dígito a uno de los placeholders
  const index = placeholders[lastDigit % placeholders.length]
  return `/img/placeholder-user${index}.png`
}

export const UserAvatar = ({ src, name, className, size = "md" }: UserAvatarProps) => {
  const getInitials = (fullName = "") => {
    return fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase()
  }

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      <AvatarImage src={src || stringPlaceholder(name)} alt={name} />
      <AvatarFallback className="bg-primary/10 text-primary font-semibold">
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  )
}
